import { runtime } from '@antv/g-lite';
import { AdvancedCamera } from './AdvancedCamera';

export { AdvancedCamera };

runtime.CameraContribution = AdvancedCamera;
